var _ = require('underscore');
var defaultValueToDisplayText = require("../../../shared/defaultValueToDisplayText");

var module = angular.module('octopusApp.library');


module.controller('StepTemplateEditController', function ($scope, $stateParams, $state, $location,
                                                          busy, octopusRepository, unsavedChanges,
                                                          templateParameterModal, pluginRegistry, $uibModal, $q, $filter, actionTemplateProcessor) {
    $scope.resolveLink = $filter('resolveLink');

    var isLoading = $scope.isLoading = busy.create();
    var isSaving = $scope.isSaving = busy.create();

    var id = $stateParams["id"];
    var actionType = $stateParams["actionType"];

    $scope.isCommunityTemplate = false;


    $scope.defaultValueToDisplayText = defaultValueToDisplayText;

    $scope.noprop = {};
    var queryString = $location.search();
    if (queryString.activeTab) {
        $scope.tab = queryString.activeTab;
    } else {
        $scope.tab = id ? 'step' : 'settings';
    }

    $scope.changeTab = function (selectedTab) {
        $scope.tab = selectedTab;
        $scope.unsavedChanges.ignoreNextLocationChange();
        $location.search('activeTab', selectedTab);
    };

    $scope.unsavedChanges = unsavedChanges;

    var updateLocalNames = function () {
        if ($scope.actionTemplate && $scope.actionTemplate.Parameters) {
            $scope.localNames = _.pluck(_.sortBy($scope.actionTemplate.Parameters, 'Name'), 'Name');
        } else {
            $scope.localNames = [];
        }
    };

    var validateFeatures = function () {
        if ($scope.actionTemplate && $scope.actionTemplate.Properties && $scope.actionTemplate.Properties["Octopus.Action.EnabledFeatures"]) {
            var enabledFeatures = $scope.actionTemplate.Properties["Octopus.Action.EnabledFeatures"].split(',');
            var errors = [];
            _.each(enabledFeatures, function (f) {
                var feature = pluginRegistry.getFeature(f);
                if (feature.validate) {
                    feature.validate($scope.actionTemplate, $scope.step, errors);
                }
            });

            if (errors.length > 0) {
                isSaving.showErrors("There was a problem with your request.", errors);
                return false;
            }
        }

        return true;
    };

    var actionTemplateLoader;
    if (id) {
        actionTemplateLoader = octopusRepository.ActionTemplates.get(id);
    } else {
        actionTemplateLoader = octopusRepository.ActionTemplates.search().then(function(allStepTemplates) {
            var tmpTemplate = _.find(allStepTemplates, function(template) {
                return template.Type === actionType && template.IsBuiltIn && template.IsInstalled;
            });

            var template = {ActionType: actionType, Properties: {}, Parameters: [], Links: tmpTemplate.Links};
            return template;
        });
    }

    function updateActions(actionTemplate, actionIdsByProcessId, usagesToUpdate){
        var work = octopusRepository.ActionTemplates
                                    .updateActions(actionTemplate, actionIdsByProcessId)
                                    .then(function(data){
                                            return $scope.reloadAndPreserveUrl();
                                        }, function(error){
                                            if (error.StatusCode !== 400) {
                                                throw error;
                                            }

                                            return $scope.resolveMergeConflicts(usagesToUpdate, error.Details)
                                                        .catch(function(){
                                                            return $scope.reloadAndPreserveUrl();
                                                        });
                                        });
        return isSaving.promise(work);
    }

    $scope.updateAllProjects = function (usages) {
        var actionTemplateVersion = $scope.actionTemplate.Version.toString();
        var usagesToUpdate = usages.filter(function(usage){
            return usage.Version !== actionTemplateVersion;
        });

        var actionIdsByProcessId = _.groupBy(usagesToUpdate, 'DeploymentProcessId');
        for(var propertyName in actionIdsByProcessId) {
            actionIdsByProcessId[propertyName] = actionIdsByProcessId[propertyName].map(function(usage) {return usage.ActionId;});
        }

        return updateActions($scope.actionTemplate, actionIdsByProcessId, usagesToUpdate);
    };

    $scope.updateAction = function (usage) {

        var actionIdsByProcessId = {};
        actionIdsByProcessId[usage.DeploymentProcessId] = [usage.ActionId];

        return updateActions($scope.actionTemplate, actionIdsByProcessId, [usage]);
    };

    $scope.reloadAndPreserveUrl = function(){
        return $state.transitionTo($state.current, $stateParams, { reload: true, inherit: false, notify: true, location: false});
    };

    $scope.resolveMergeConflicts = function(usages, mergeResults){
        return $uibModal.open({
            backdrop: true,
            keyboard: true,
            templateUrl: 'areas/library/steps/views/merge_conflict_resolution.html',
            controller: 'MergeConflictResolutionController',
            controllerAs: 'vm',
            windowClass : "merge-conflict-resolution",
            resolve: {
                usages: function () {
                    return usages;
                },
                mergeResults: function(){
                    return mergeResults;
                },
                actionTemplate : function(){
                    return $scope.actionTemplate;
                }
            }
        }).result;
    };

    isLoading.promise(actionTemplateLoader.then(function (actionTemplate) {

        var stepTemplateLoader = actionTemplate.CommunityActionTemplateId ? octopusRepository.CommunityActionTemplates.get(actionTemplate.CommunityActionTemplateId) : $q.resolve([]);
        var feedsLoader = octopusRepository.Feeds.all();
        var loaders = [stepTemplateLoader, feedsLoader];

        isLoading.promise($q.all(loaders).then(function (results) {

            var communityStepTemplate = results[0];
            var feeds = results[1];

            $scope.actionTemplate = actionTemplate;
            $scope.communityStepTemplate = communityStepTemplate;
            $scope.hasUpdate = communityStepTemplate && actionTemplate.Version < communityStepTemplate.Version;
            $scope.isCommunityTemplate = actionTemplate.CommunityActionTemplateId != null;
            $scope.feeds = feeds;
            $scope.hasFeatures = pluginRegistry.hasFeaturesForAction(actionTemplate.ActionType);

            if (actionTemplate.Id) {
                isLoading.promise(octopusRepository.ActionTemplates.getUsage(actionTemplate).then(function (usage) {
                    $scope.usage = usage;

                    $scope.pendingUpdates = 0;
                    _.each(usage, function (u) {
                        if (u.Version.toString() !== actionTemplate.Version.toString()) {
                            $scope.pendingUpdates++;
                        }
                    });
                }));
            }

            updateLocalNames();

            $scope.templateEditor = templateParameterModal.create($scope.actionTemplate.Parameters, {
                name: 'Step Template Parameter',
                onChange: updateLocalNames
            });

            $scope.showAddFeaturesDialog = function () {
                $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/projects/views/process_features_dialog.html',
                    controller: 'ProjectProcessFeaturesController',
                    dialogClass: 'modal modal-big',
                    resolve: {
                        currentAction: function () {
                            return $scope.actionTemplate;
                        },
                        currentStep: function () {
                            return null;
                        }
                    }
                });
            };

            $scope.updateTemplate = function () {

                $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/library/steps/views/community_step_template_update.html',
                    controller: 'CommunityStepTemplateUpdateController',
                    resolve: {
                        actionTemplate: function () {
                            return $scope.actionTemplate;
                        },
                        communityStepTemplate: function() {
                            return $scope.communityStepTemplate;
                        }
                    }
                }).result.then(function (update) {
                    if (update) {
                        return actionTemplateProcessor.updateCommunityActionTemplateInstallation($scope.communityStepTemplate, null, isSaving)
                                                        .then(function () {
                                                            $scope.changeTab('usage');
                                                            $state.reload();
                                                        });
                    }
                });

            };

            $scope.saveAsCopy = function () {
                if (validateFeatures()) {
                    $uibModal.open({
                        backdrop: true,
                        keyboard: true,
                        templateUrl: 'areas/library/steps/views/community_step_template_saveas.html',
                        controller: 'CommunityStepTemplateSaveAsController',
                        resolve: {
                            action: function () {
                                return $scope.actionTemplate;
                            }
                        }
                    }).result.then(function (newActionName) {
                        if (newActionName) {
                            actionTemplateProcessor.cloneActionTemplate(
                                $scope.actionTemplate,
                                newActionName,
                                function(actionTemplate) { return "/library/steptemplates/" + actionTemplate.Id; },
                                isSaving,
                                function() { unsavedChanges.saved(); });
                        }
                    });
                }
            };

            $scope.save = function () {
                if (validateFeatures()) {
                    var isNew = !id;
                    isSaving.promise(octopusRepository.ActionTemplates.save($scope.actionTemplate).then(function (saved) {
                        unsavedChanges.saved();
                        if (isNew) {
                            $location.path('/library/steptemplates/' + saved.Id);
                        } else {
                            $state.reload();
                        }
                    }));
                }
            };

            $scope.export = function () {
                // Prevent exporting until changes are saved
                if (unsavedChanges.hasUnsavedChanges()) {
                    return;
                }

                $uibModal.open({
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/shared/views/export_entity_dialog.html',
                    controller: 'ExportEntityDialogController',
                    dialogClass: 'modal modal-big',
                    resolve: {
                        entity: function () {
                            return $scope.actionTemplate;
                        },
                        entityType: function () {
                            return 'ActionTemplate';
                        }
                    }
                });
            };
        }));
    }));
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/library/steps/controllers/step_template_edit_controller.js
// module id = 7204974008540822
// module chunks = 1